import { Page } from "../../types/pageTypes";
import ForecastAccuracyPage from './ForecastAccuracyOverview';

export const page: Page = {
    title: 'forecastAccuracy.title',
    path: '/forecastAccuracy',
    icon: 'bullseye',
    component: ForecastAccuracyPage
};
